module.exports = __webpack_public_path__ + "7265cb5950282cdd67ba5ce4cf392bfe.png";